// (2)获取浏览器信息
const getBrowserInfo = () => {
    const ua = navigator.userAgent
    let tem
    let M =
        ua.match(
            /(opera|chrome|safari|firefox|edge|msie|trident(?=\/))\/?\s*([\d.]+)/i
        ) || ([] as any)

    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+([\d.]+)/g.exec(ua) || []
        return {name: 'IE', version: tem[1] || ''}
    }
    if (M[1] === 'Chrome') {
        tem = ua.match(/\b(OPR|Edg)\/([\d.]+)/) as any
        if (tem) {
            return {
                name: tem[1].replace('OPR', 'Opera').replace('Edg', 'Edge'),
                version: tem[2]
            }
        }
    }

    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?']
    tem = ua.match(/version\/([\d.]+)/i)
    if (tem) M.splice(1, 1, tem[1])
    return {name: M[0], version: M[1]}
}

export async function landReportEvent(apiLandData: {
    pro_channel?: string
    pixel_id: string
    book_id?: string
    chapter_id?: string
    chapter_order?: string
}) {
    const route = useRoute()
    const {
        campaign_name,
        campaign_id,
        adset_name,
        adset_id,
        ad_id,
        ad_name,
        utm_source,
        fbclid
    } = route.query
    const clientInfo = useState('clientInfo') as any
    try {
        const {initAndWaitFbc} = useFacebookPixel(apiLandData.pixel_id)
        await initAndWaitFbc()
    } catch (e) {
        console.log(e)
    }
    // === 4. 确保 FB SDK 已加载完成 ===
    try {
        // 获取基础设备与环境信息
        const userAgent = navigator.userAgent || ''
        const url = window.location.href
        const timestamp = Date.now()
        const userInfo = useCookie('login_info').value as any
        // 处理上报信息
        const ads_data = {
            campaign_name: campaign_name,
            campaign_id: campaign_id,
            adset_name: adset_name,
            adset_id: adset_id,
            ad_name: ad_name,
            ad_id: ad_id,
            utm_source: utm_source,
            click_id: fbclid || ''
        }
        // 用户数据
        const user_data = {
            user_id: userInfo?.user_id || '',
            uuid: useCookie('guest_id').value || '',
            os_type: /iPhone|iPad|iPod/i.test(userAgent)
                ? 2
                : /Android/i.test(userAgent)
                    ? 1
                    : 1
        }

        const land_data = {
            ...apiLandData,
            pro_code: route.params.id,
            ip: clientInfo.value.ip,
            fbc: useCookie('_fbc').value || '',
            fbp: useCookie('_fbp').value || '',
            url,
            timestamp
        }
        // 客户端数据
        const client_data = {
            sw: window.screen.width,
            sh: window.screen.height,
            user_agent: userAgent,
            app_version: `${getBrowserInfo().name}_${getBrowserInfo().version}`,
            os_version: navigator.platform || ''
        }
        const body = {
            user_data,
            ads_data,
            land_data,
            client_data
        }
        console.log('[📡 上报广告落地页信息]', body)
        // === 5. 发起请求 ===
        await useClientFetch('/api/ads/report-ads-info', {
            method: 'POST',
            body
        })
    } catch (e) {
        console.error('Landing report error:', e)
    }
}
